import * as React from 'react';

import { Messages } from '../../../codegen/Localize';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '../../state/SpaceInfo';
import { ConnectedQueryParamUpdateProvider } from '../RouterHelpers/QueryParamUpdateProvider';
import { ConnectedSpaceInfoProvider } from '../RouterHelpers/SpaceInfoProvider';
import { ConnectedBackgroundJobsSpace } from './ConnectedBackgroundJobsSpace';
import { BrowserTitleService } from '../../../commonInfra/services/BrowserTitleService';

export interface BackgroundJobsSpaceProviderOwnProps extends ReactDirectiveProps{
  readonly siteName: string;
  readonly routeLocationSearch: string;
  readonly routeLocationPath: string;
}

export type BackgroundJobsSpaceProviderProps = BackgroundJobsSpaceProviderOwnProps;

export const BackgroundJobsSpaceProviderComponent: React.FunctionComponent<BackgroundJobsSpaceProviderProps> = props => {

  BrowserTitleService.setTitleWithTranslatedSpace({ translatedSpaceName: Messages.backgroundJobs() });

  const spaceInfo: SpaceInfo = {
    item: SpaceItemForNonEntitySpace,
    spaceType: 'backgroundJobs',
    subspaceName: undefined,
  };

  return (
    <ConnectedSpaceInfoProvider spaceInfo={spaceInfo}>
      <ConnectedQueryParamUpdateProvider
          shouldUpdateFilters={true}
          shouldUpdateContentTypes={false}
          shouldUpdateBreadcrumbs={false}
          shouldUpdateSort={true}
          routeLocationSearch={props.routeLocationSearch}
          routeLocationPath={props.routeLocationPath}>
        <ConnectedBackgroundJobsSpace {...props} />
      </ConnectedQueryParamUpdateProvider>
    </ConnectedSpaceInfoProvider>
  );
};

export const BackgroundJobsSpaceProvider = BackgroundJobsSpaceProviderComponent;
